import React, { useState } from "react";
import axios from "axios";
import { Link } from "react-router-dom";
import { TiSocialLinkedin, TiSocialFacebook } from "react-icons/ti";
import { SlSocialInstagram } from "react-icons/sl";
import { SiGithub } from "react-icons/si";
import { buildApiUrl } from "../utils/api";

function Footer() {
    const [email, setEmail] = useState("");
    const [status, setStatus] = useState("");

    const handleSubmit = async (event) => {
        event.preventDefault();

        try {
            await axios.post(buildApiUrl("/api/subscriber/create"), { email });
            setStatus("Subscribed successfully.");
            setEmail("");
        } catch (error) {
            console.error("Error creating subscription", error);
            setStatus("Subscription failed. Please try again.");
        }
    };

    return (
        <footer className="site-footer">
            <div className="container">
                <div className="row g-4">
                    <div className="col-lg-3">
                        <div className="site-footer-brand">
                            <span>3PL Search</span>
                            <p>
                                We help brands, distributors, and supply chain teams shortlist the right warehouse
                                partners and move from enquiry to quoted options faster.
                            </p>
                        </div>
                        <div className="site-footer-social">
                            <a href="https://www.linkedin.com" target="_blank" rel="noreferrer" aria-label="LinkedIn">
                                <TiSocialLinkedin />
                            </a>
                            <a href="https://www.facebook.com" target="_blank" rel="noreferrer" aria-label="Facebook">
                                <TiSocialFacebook />
                            </a>
                            <a href="https://www.instagram.com" target="_blank" rel="noreferrer" aria-label="Instagram">
                                <SlSocialInstagram />
                            </a>
                            <a href="https://github.com" target="_blank" rel="noreferrer" aria-label="GitHub">
                                <SiGithub />
                            </a>
                        </div>
                    </div>

                    <div className="col-sm-6 col-lg-2">
                        <h4>Explore</h4>
                        <div className="site-footer-links">
                            <Link to="/">Home</Link>
                            <Link to="/finder">Browse warehouses</Link>
                            <Link to="/3pl_booking">Request a match</Link>
                            <Link to="/provider">List your 3PL</Link>
                        </div>
                    </div>

                    <div className="col-sm-6 col-lg-2">
                        <h4>Support</h4>
                        <div className="site-footer-links">
                            <Link to="/services">Solutions</Link>
                            <Link to="/blog">Insights</Link>
                            <Link to="/contact">Contact us</Link>
                            <Link to="/userLogin">Buyer login</Link>
                        </div>
                    </div>

                    <div className="col-sm-6 col-lg-2">
                        <h4>Legal</h4>
                        <div className="site-footer-links">
                            <Link to="/privacy-policy">Privacy Policy</Link>
                            <Link to="/terms">Terms of Service</Link>
                            <Link to="/cookie-policy">Cookie Policy</Link>
                        </div>
                    </div>

                    <div className="col-lg-3">
                        <h4>Stay informed</h4>
                        <p className="site-footer-copy">
                            Get updates on warehouse availability, logistics trends, and new partner regions.
                        </p>
                        <form className="site-footer-form" onSubmit={handleSubmit}>
                            <input
                                type="email"
                                name="email"
                                value={email}
                                onChange={(event) => setEmail(event.target.value)}
                                placeholder="Enter your work email"
                                required
                            />
                            <button type="submit">Subscribe</button>
                        </form>
                        {status ? <small className="site-footer-status">{status}</small> : null}
                    </div>
                </div>

                <div className="site-footer-bottom">
                    <span>&copy; {new Date().getFullYear()} 3PL Search by Shipcube. All rights reserved.</span>
                    <div className="d-flex gap-3 flex-wrap">
                        <Link to="/privacy-policy" style={{ color: "inherit", opacity: 0.7, fontSize: "0.85rem" }}>Privacy Policy</Link>
                        <Link to="/terms" style={{ color: "inherit", opacity: 0.7, fontSize: "0.85rem" }}>Terms of Service</Link>
                        <Link to="/contact" style={{ color: "inherit", opacity: 0.7, fontSize: "0.85rem" }}>Contact</Link>
                    </div>
                </div>
            </div>
        </footer>
    );
}

export default Footer;
